// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__1O2iq","selects":"Documents_selects__wwOvm"};